/**
 * Fan Choice Awards submission form — birthdate validation.
 * @see https://www.packerseverywhere.com/fan-choice-awards-2022/submit-your-entry
 */

function createBirthdateErrorElement(error: string): void {
  const birthdateRow = document.querySelector(
    'div.form-date-picker.input-row, div[class="form-date-picker input-row"]',
  );
  if (!birthdateRow) return;

  const divError = document.createElement('div');
  divError.id = 'birthdateError';
  divError.innerHTML = error;
  divError.className = 'fanchoice-submit-form__error field-validation-error';
  birthdateRow.appendChild(divError);
}

function validateBirthDate(dateField: Element): boolean {
  const currentDate = new Date();
  const inputField = dateField.querySelector('input[type="date"]') as HTMLInputElement | null;
  const errorMessage = document.getElementById('birthdateError');
  errorMessage?.remove();

  if (!inputField?.value) {
    return true;
  }

  const userDate = new Date(inputField.value);

  if (Number.isNaN(userDate.getTime()) || userDate > currentDate) {
    createBirthdateErrorElement('Please enter a valid date that is not in the future.');
    return false;
  }

  const minAgeDate = new Date();
  minAgeDate.setFullYear(minAgeDate.getFullYear() - 18);
  if (userDate > minAgeDate) {
    createBirthdateErrorElement('You must be at least 18 years or older to enter.');
    return false;
  }

  return true;
}

export function setupFanSubmitForm(): void {
  const form = document.querySelector('.fanchoice-submit-form form');
  if (!form) return;

  const birthDateField = form.querySelector('.form-date-picker');
  if (!birthDateField) return;

  form.addEventListener('submit', () => {
    validateBirthDate(birthDateField);
  });
}

setupFanSubmitForm();
